import React from 'react';
import styled, { css } from 'styled-components';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

import { Nullable } from '@tager/web-core';

import { media } from '@/utils/mixin';
import { getYouTubeId } from '@/utils/common';

interface Props {
  src: string;
  caption: Nullable<string>;
}

function Youtube({ src, caption }: Props) {
  return (
    <Component>
      <Figure>
        <VideoPlayer>
          <LiteYouTubeEmbed id={getYouTubeId(src)} title="YouTube Embed" />
        </VideoPlayer>
        {caption ? <Figcaption>{caption}</Figcaption> : null}
      </Figure>
    </Component>
  );
}

export default Youtube;

const Component = styled.div`
  margin: 20px auto;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(css`
    max-width: 100%;
  `)}
`;

const Figure = styled.figure`
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100% !important;
`;

const VideoPlayer = styled.div`
  position: relative;
  padding-bottom: 56.159%;

  article {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

const Figcaption = styled.figcaption`
  margin-top: 15px;

  font-weight: 300;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: ${(props) => props.theme.black100};
  opacity: 0.5;

  @media (min-width: 1400px) {
    margin: 40px auto;

    font-size: 18px;
  }
`;
